<template>
	<div>
<div id="pag" style="position: absolute; top: 0;"></div>
<!--
	
-->


<transition v-if="lightboxQuiz" name="menu-popover">
      <div class="lightbox" >
		<!--
        <h2 class="closeX" @click="closeQuizLightbox()">
          <a>&#215;</a>
        </h2>
		-->

        <div class="lightbox-quiz">
		
			<quiz :quizData="lightboxQuiz" :ModuleID="ModuleID" :closeQuizLightbox="closeQuizLightbox" :loadNewContent="loadNewContent" :completeQuiz="completeQuiz"></quiz>
		
		</div>

      </div>
</transition>

<!--
	
-->
<transition name="menu-popover">
      <div v-if="lightboxVideo" class="lightbox" @click="closeLightbox()">
        <h2 class="closeX" @click="closeLightbox()">
          <a>&#215;</a>
        </h2>
        <div class="lightbox-vid" v-html="lightboxVideo"></div>
        <!-- <img :src="lightboxImage" @click="closeLightbox()"/> -->
      </div>
    </transition>
	
	<div class="questions inside-banner mobile-top">
        <section class="pixelsbg bs-shadow" style="padding: 30px 0 20px;">
      <div class="container">
          <div class="container">
        <h1 class="text-white lh1" style="margin-bottom: 10px;">FORTified Learning</h1>
	
	
        <p class="text-white lh1" style="font-size: 18px; font-weight: 300; margin-bottom: 20px;">Sharpen your Spacesaver solutions knowledge and ability to leverage the right solution in any sales scenario. </p>
					<div class="row" style="margin-bottom: 10px;">
					<div class="col-12 col-sm-12 col-lg-4">
						<div class="mb-2 bs-shadow" style="padding: 20px; text-align: center;     background: rgba(255, 255, 255, 0.2);
    color: #fff;
    border-radius: 4px;">
							<h3>{{ animatedStats.totalQuizzesAvailable }}</h3>
							<p class="mb0" style="font-weight: 300;">Total Courses Available</p>
							
						</div>
					</div>
					<div class="col-12 col-sm-12 col-lg-4">
						<div class="mb-2 bs-shadow" style="padding: 20px; text-align: center;     background: rgba(255, 255, 255, 0.2);
    color: #fff;
    border-radius: 4px;">
							<h3>{{ animatedStats.totalCompletedLastThreeYears }}</h3>
							<p class="mb0" style="font-weight: 300;">Total Quiz Completions</p>
							
						</div>
					</div>
					<div class="col-12 col-sm-12 col-lg-4">
						<div class="mb-2 bs-shadow" style="padding: 20px; text-align: center;     background: rgba(255, 255, 255, 0.2);
    color: #fff;
    border-radius: 4px;">
							<h3>{{ animatedStats.totalCompletedLastYear }}</h3>
							<p class="mb0" style="font-weight: 300;">Quiz Completions ({{ currentYear }})</p>
							
						</div>
					</div>
				</div>
	
		        <div class="input-wrap">
  <input
    id="announcements-step-1"
    class="top-search mt0"
    type="text"
    placeholder="Search courses by title"
    style="padding: 15px;"
    v-model="search"
	@keyup.enter="searchPosts"
  />

 

  <button
    :class="[showButton ? 'clear-btn' : 'clear-hide']"
    @click="clearSearch"
    type="button"
    class="d-flex align-items-center pr-3 clear-btn"
  >
    <svg
      class="w-4 h-4 text-[#429da8] hover:text-[#1E3040]"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
    >
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path
        d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
      ></path>
    </svg>
  </button>
 
</div>

<div class="search-btns">

          <div class="left-side" style="margin-right: 10px">
  <select
                class="form-control"
                v-model="selectedProduct"
                style="margin-right: 10px; min-width: 200px;"
                id="eto-step-2"
              >
                <option
                  :value="null"
                  selected
                  class="all-contractors"
                  id="firstSelector"
                  style="text-transform: capitalize !important"
                >
                  All Products
                </option>
                <option
                  v-for="product in products"
                  :key="product.id"
                  :value="product.name"
                  id="text"
                >
                  {{ product.name }}
                </option>
              </select>
			  </div>
  <div class="right-side">
    <button
      v-if="(search.trim().length || products.length)"
      @click="searchPosts"
      class="thesearchbutton"
      style="margin-right: 0;"
    >
      <span class="material-icons">search</span>
      {{ " " }} Search
    </button>
    <button v-else class="thesearchbutton" disabled style="margin-right: 0;">
      <span class="material-icons">search</span>
      {{ " " }} Search
    </button>
  </div>
</div>




		<!--
		<div class="badges" style="display: flex;">

		
			<transition name="badge-animation" mode="out-in">
			<span v-if="complete >= 1" style="margin-right: 30px; text-align: center; max-width: 60px;">
				<img style="width: 100%;" src="/training-images/explorer-badge.svg" />
				<p style="color: #fff;">Explorer</p>
			</span>
			<span v-else style="margin-right: 30px; text-align: center; max-width: 60px; opacity: 30%;">
				<img style="width: 100%;" src="/training-images/blank-badge.svg" />
				<p style="color: #fff; opacity: 0;">Explorer</p>
			</span>
			</transition>

		
			<transition name="badge-animation" mode="out-in">
			<span v-if="complete >= 10" style="margin-right: 30px; text-align: center; max-width: 60px;">
				<img style="width: 100%;" src="/training-images/visionary-badge.svg" />
				<p style="color: #fff;">Visionary</p>
			</span>
			<span v-else style="margin-right: 30px; text-align: center; max-width: 60px; opacity: 30%;">
				<img style="width: 100%;" src="/training-images/blank-badge.svg" />
				<p style="color: #fff; opacity: 0;">Visionary</p>
			</span>
			</transition>

	
			<transition name="badge-animation" mode="out-in">
			<span v-if="complete >= 30" style="margin-right: 30px; text-align: center; max-width: 60px;">
				<img style="width: 100%;" src="/training-images/innovator-badge.svg" />
				<p style="color: #fff;">Innovator</p>
			</span>
			<span v-else style="margin-right: 30px; text-align: center; max-width: 60px; opacity: 30%;">
				<img style="width: 100%;" src="/training-images/blank-badge.svg" />
				<p style="color: #fff; opacity: 0;">Innovator</p>
			</span>
			</transition>

		</div>
		-->
		
      </div>
	  

          <!--
        <input
          class="top-search bs-large mt0"
          type="text"
          placeholder="Search All Posts..."
          v-model="search"
          @click="searchReset()"
        />
        -->
      </div>
	  
    </section>
<!---->
    		<section class="faq-tease" style="margin-top: 20px; margin-bottom: 20px;">
			<div class="container">

	
						
					
			
							<TrainingPagination :currPage="currPage" :totalPage="totalPage" :filteredPosts="filteredPosts" :setPage="setPage" :countOfPage="countOfPage"/>

		
  


				<div
					v-if="loading == true || !trainingData.length"
					class="col-xs-12 col-sm-12 col-12 col-lg-12"
					style="
              min-height: 302px; display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 20px;"
				>
					<div class="flex-box-wrap">
						<div class="flex-internal">
							<atom-spinner
								:animation-duration="1000"
								:size="40"
								:color="'#333'"
							/>
							<p style="color:#333;">Loading......</p>
						</div>
					</div>
				</div>

				<div v-else class="accordion" id="faq-01" data-config-id="faq">
					<div class="row">
						
					
					<div
						v-for="(item, index) in paginatedPosts"
						:key="item.index"
						class="col-12 col-sm-12 col-6 col-lg-4 block"
					>
					<div class="mb-2 border-bottom bgwhite bs-shadow">
						
							
							<div>
								<img :src="item.Image" style="width: 100%; margin-bottom: 20px;"></img>
								<h3 id="faq-heading1-01 faq-heading">{{item.Title}}</h3>
								<p class="small-lh cool-desc double-line" style="margin-bottom: 5px; max-height: 120px; overflow: hidden;"><b>{{ $options.filters.truncate(item.Description) }}</b></p>
								
								<div class="Install-bottom dflex mt20" style="align-items: center;">
							
								<span v-if="item.progress === 0" style="font-size: 18px; font-weight: 300;">

									<small style="font-weight: 300; display: flex; align-items: center; gap: 6px;" v-if="Number(item.Length) < 60">
<svg 
  width="20" 
  height="20" 
  viewBox="0 0 100 100" 
  fill="#575757" 
  xmlns="http://www.w3.org/2000/svg"
  style="flex-shrink: 0;"   
>
  <path 
    d="M50 96c-25.4 0-46-20.6-46-46s20.6-46 46-46 46 20.6 46 46-20.6 46-46 46z
       m-4-73v27c0 1.5.8 2.8 2 3.5l17.4 10c2 1.1 4.4.5 5.5-1.5 1.1-1.9.5-4.4-1.5-5.5l-15.4-8.9V27c0-2.2-1.8-4-4-4s-4 1.8-4 4z
       m31 .2c-14.8-14.8-38.8-14.8-53.6 0-14.8 14.8-14.8 38.8 0 53.6 14.8 14.8 38.8 14.8 53.6 0s14.8-38.8 0-53.6z"
    fill-rule="evenodd"
  />
</svg>
<span class="time-desc ">About</span> {{item.Length}} minutes</small> 
									
									<small style="font-weight: 300; display: flex; align-items: center; gap: 6px;" v-else-if="Math.round(Number(item.Length) / 60) === 1">
									<span class="time-desc ">About</span> {{ roundedHalfHour(Number(item.Length)) }} Hour 
									</small>
									<small style="font-weight: 300;" v-else>
									<span class="time-desc ">About</span> {{ roundedHalfHour(Number(item.Length)) }} Hours
									</small>
									
								</span>
								<span v-else style="font-size: 18px; font-weight: 300;">
<small 
  style="font-weight: 300; display: flex; align-items: center; gap: 3px;" 
  v-if="item.progress === 100"
>

<svg xmlns="http://www.w3.org/2000/svg"  width="30" 
  height="30"  data-name="Layer 1" viewBox="0 0 100 100" x="0px" y="0px"><path fill="#00b4b4" d="M76.82,34.47A8,8,0,0,1,71.35,37,25.18,25.18,0,0,1,73,40.27,25,25,0,1,1,63,28.66a8,8,0,0,1,2.52-5.49,31.51,31.51,0,1,0,11.28,11.3Z"/><path d="M47.76,52.75l-7.76-7-4,4.46,10,9A3,3,0,0,0,48,60h.17a3,3,0,0,0,2.08-1l16-18-4.48-4Z" fill="#00b4b4"/><circle fill="#00b4b4" cx="71" cy="29" r="3"/></svg>

  <span>Completed</span>
</small>
<small 
  style="font-weight: 300; display: flex; align-items: center; gap: 6px;" 
  v-else
>
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 24 24"
  >
    <!-- background ring (unchanged, full faint circle) -->
    <circle 
      cx="12" 
      cy="12" 
      r="10" 
      fill="none" 
      stroke="currentColor" 
      stroke-width="3" 
      opacity="0.2"
    />

    <!-- progress ring – rotated 180° so it starts from LEFT -->
    <circle 
      cx="12" 
      cy="12" 
      r="10" 
      fill="none" 
      stroke="#00b4b4" 
      stroke-width="3" 
      stroke-linecap="round"
      transform="rotate(180 12 12)"
      :stroke-dasharray="`${(item.progress / 100) * 62.8} 62.8`"
    />
  </svg>
  <span class="time-desc ">In Progress</span> ({{ item.progress }}%)
</small>

								</span>

								<router-link
									:to="`/fortified-learning/course/${item.ID}`"
									class="mb0 lh1 mlauto list-btn"
									style="font-size: 12px;"
									>
									View Course
									</router-link>
								
								</div>

					
								
							
									
							
							</div>

						</div>
						<div
							class="collapse answer"
							:id="'faq-collapse1-' + index"
							aria-labelledby="faq-heading1-01"
							data-parent="#faq-01"
							style="padding: 0 22px"
						>
						
                      
							<p id="answer" style="margin-bottom: 5px;"><b>{{ item.Description }}</b></p>

							<!--
							<ul v-if="item.Docs && item.Docs.length" style="list-style-type: none; margin-bottom: 5px;">
								<li v-for="(item, index) in item.Docs" :key="index" style="display: flex; align-items: center; margin-bottom: 5px;"
								>
									<a :href="item.Link" target="_blank"><span><img src="/training-images/training-doc.svg" style="max-width: 18px; margin-right: 5px;"/></span><span class="vid-link" style="color: #00b4b4;">{{ item.Title }}</span></a>
								</li>
							</ul>
							-->

							<!--
							<ul v-if="item.Docs?.length" style="list-style-type: none; margin-bottom: 5px;">
								<li 
								v-for="(doc, index) in item.Docs.slice().sort((a, b) => new Date(a.Added) - new Date(b.Added))" 
								:key="index" 
								style="display: flex; align-items: center; margin-bottom: 5px;"
								>
									<a :href="doc.Link" target="_blank">
										<span>
											<img src="/training-images/training-doc.svg" style="max-width: 18px; margin-right: 5px;"/>
										</span>
										<span class="vid-link" style="color: #00b4b4;">
											{{ doc.Title }}
										</span>
									</a>
								</li>
							</ul>
							-->
							

							
						<!--
							<ul v-if="item.Vids && item.Vids.length" style="list-style-type: none; margin-bottom: 5px;">
								<li v-for="(vid, index) in item.Vids" :key="index" style="display: flex; align-items: center; margin-bottom: 5px;"
								@click="showLightboxVideo(vid.Video)">
									<span><img src="/training-images/training-video.svg" style="max-width: 18px; margin-right: 5px;"/></span><span class="vid-link" style="color: #00b4b4;">{{ vid.Title }}</span>
								</li>
							</ul>
						-->

						<!--
						
						<ul v-if="item.Vids?.length" style="list-style-type: none; margin-bottom: 5px;">
								<li 
								v-for="(vid, index) in item.Vids.slice().sort((a, b) => new Date(a.Added) - new Date(b.Added))" 
								:key="index" 
								style="display: flex; align-items: center; margin-bottom: 5px;"
								@click="showLightboxVideo(vid.Video)"
								>
									<span>
										<img src="/training-images/training-video.svg" style="max-width: 18px; margin-right: 5px;"/>
									</span>
									<span class="vid-link" style="color: #00b4b4;">
										{{ vid.Title }}
									</span>
								</li>
							</ul>
						-->
							


							<!--
							<ul v-if="item.Quizzes?.length && item.Quizzes[0].Published == 1" style="list-style-type: none; margin-bottom: 5px;">
								<li style="display: flex; align-items: center; margin-bottom: 5px;"
								@click="showLightboxQuiz(item.Quizzes[0], item.ID)"
								>
									<span><img src="/training-images/training-quiz.svg" style="max-width: 18px; margin-right: 5px;"/></span><span class="vid-link" style="color: #00b4b4;">{{ item.Quizzes[0].Title }}</span>
								</li>
							</ul>
							-->
							
						
									
							


							

							
						
                           
							<!--
                            <p id="answer">{{ faq.Body }}</p>
							-->
						</div>
						</div>
					</div>
					</div>
					<TrainingPagination :currPage="currPage" :totalPage="totalPage" :filteredPosts="filteredPosts" :setPage="setPage" :countOfPage="countOfPage"/>
				</div>
			
		
		</section>

	</div>
</div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
// import TrainingData from "../data/trainingData.json"
import Quiz from '../components/Quiz.vue';
import TrainingPagination from '@/components/Pagination/TrainingPagination.vue';
import BackButton from '@/components/Buttons/BackButton.vue';

//old auth with admin priveleges
//headers: {Authorization:'Bearer spacesaver/ab3f641f910eb693804bc5b097a5bda6'}

const auth = {
	headers: {
		Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
	},
};

export default {
	name: "FortLearning",
	components: {
		AtomSpinner,
		Quiz,
		TrainingPagination,
		BackButton
	},
	data() {
		return {
			// /api/v1/product-courses/all-courses/2DD2C984-A3DD-4923-AC52-5B04382989AD
			server: import.meta.env.VITE_APP_SERVER_URL,
			// server: 'http://localhost:5002',
			pageSlug: "",
			currPage: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
      		search: this.$route.query.search || '',
    		searchStarted: !!this.$route.query.search,
			selectedProduct: this.$route.query.product || null,
			activeProduct: this.$route.query.product || null,
			countOfPage: 6,
			msg: "",
			offsetVal: 0,
			searchValue: "",
            media: [],
            faqPosts: [],
			trainingData: [],
			loading: false,
			lightboxVideo: "",
			lightboxQuiz: null,
			ModuleID: null,
			complete: 0,
			congrats: 0,
			animatedStats: {
			totalQuizzesAvailable: 0,
			totalCompletedLastThreeYears: 0,
			totalCompletedLastYear: 0,
			completedPercentageLastYear: 0
			},
			animationDuration: 500,  // ms — adjust for speed
			courses: [
				{ id: 1, title: "EZ Power", category: "Mobile",description: "Learn how to configure initial preferences for Spacesaver’s EZ Power solution, designed for Eclipse powered mobile systems. This course covers setup essentials to ensure seamless integration and optimal performance without the need for on-site electricians.", image: "/training-thumbnails/EZPower-thumbnail.jpg", Length: "7" },
				{ id: 2, title: "Touchless Gesture Control", category: "Mobile", description: "Discover how Spacesaver’s Touchless Gesture Control enhances Eclipse powered mobile systems with hands-free operation. This course explains setup and functionality, productivity, and modernizing system aesthetics.", image: "/training-thumbnails/touchless-thumbnail.jpg", Length: 6 },
				{ id: 3, title: "UWR", category: "Weapons Storage", description: "Learn about Spacesaver’s Universal Weapons Rack updates designed for the U.S. military’s Next Gen Squad Weapons program. This course covers new cabinet sizes, angled brackets, and transport solutions for storing M7 rifles and M-250 machine guns efficiently and securely.", image: "/training-thumbnails/UWR-thumbnail.jpg", Length: 9 },
				{ id: 4, title: "Freestyle/Rival Lockers", category: "Lockers", description: "Explore Spacesaver’s Freestyle Lockers, designed for durability, flexibility, and customization to meet diverse storage needs. This course covers construction features, accessory options, and innovative configurations like pull-out benches and tiered lockers.", image: "/training-thumbnails/freestyle-thumbnail.jpg", Length: 12 },
				{ id: 5, title: "Flexible Shelving", category: "HighBay", description: "Explore Spacesaver’s Freestyle Lockers, designed for durability, flexibility, and customization to meet diverse storage needs. This course covers construction features, accessory options, and innovative configurations like pull-out benches and tiered lockers.", image: "/training-thumbnails/freestyle-thumbnail.jpg", Length: 14 },
				{ id: 6, title: "Mod-Glider Pro", category: "Art Racks", description: "Explore Spacesaver’s Freestyle Lockers, designed for durability, flexibility, and customization to meet diverse storage needs. This course covers construction features, accessory options, and innovative configurations like pull-out benches and tiered lockers.", image: "/training-thumbnails/freestyle-thumbnail.jpg", Length: 18 },
			],
			products: [
				/*
				
				{ id: 2, name: "Activestor" },
				{ id: 3, name: "ActivRAC" },
				 */
				{ id: 1, name: "4-Post" },
				{ id: 4, name: "Art Rack" },
				{ id: 5, name: "Cantilever" },
				{ id: 5, name: "Education/Library" },
				{ id: 6, name: "Healthcare" },
				{ id: 7, name: "Lockers" },
				{ id: 8, name: "Military" },
				{ id: 9, name: "FrameWRX" },
				{ id: 10, name: "Museum Cabinets" },
				/*
				{ id: 7, name: "Doors & Drawers" },
				
				{ id: 10, name: "Grow Crosswalk" },
				{ id: 11, name: "Gun Racks" },
				{ id: 12, name: "Laterals" },
				
				{ id: 14, name: "Parachute/Universal Container" },
				{ id: 15, name: "Personal Storage Locker" },
				  */
				{ id: 16, name: "RaptorRAC Widespan" },
				{ id: 16, name: "Sales Methodology" },
				
				{ id: 17, name: "Mobile" },
				/*
				{ id: 20, name: "UEWSS" },
				 */
				{ id: 21, name: "Weapons Storage" },
				/*
				{ id: 25, name: "Widespan Grow" },
				{ id: 26, name: "Xtend" },
				 */
				// { id: 27, name: "Other" },
			],

			/*
			   4-Post (door and drawers)
               Activestor
               Mobile (WH, SW, AR)
               Art Rack
               Cantilever
               Day Use Lockers
               Evidence Lockers
               FrameWRX
               GROW
               HighBay (Shelving, Xtend)
               Laterals
               Museum Cabinets
               Military Products (UEWSS, Parachute/Universal Container, others?) 
               Weapons Storage (Universal Weapons Rack, Shipboard UWR, Weapons Rack III)
               RaptorRAC Widespan
			   */

		};
	},
	watch: {
	'$route.query': {
        handler(newQuery) {
            // Update local state when URL changes (e.g., browser back/forward)
            this.search = newQuery.search || '';
            this.searchStarted = !!newQuery.search;
            this.selectedProduct = newQuery.product || null;
            this.activeProduct = newQuery.product || null;
            this.currPage = newQuery.page ? parseInt(newQuery.page) : 1;
        },
        deep: true,
        immediate: false
    },
    
    search(newValue) {
        if (newValue.trim() === '') {
            this.searchStarted = false;
        }
    },
	search(newValue) {
      // When user clears the input (types back to empty), allow searching again
      if (newValue.trim() === '') {
        this.searchStarted = false;
      }
    },

	/*
   '$route.query.search'(newSearch) {
    this.searchStarted = !!newSearch;

    if (newSearch) {
      this.search = newSearch;  // ← Restore the search term from URL
    } else {
      this.search = '';         // Clear when no search param
    }

    // Optional: Always go to page 1 when search query changes
    if (this.$route.query.page && this.$route.query.page !== '1') {
      this.setPage(1);
    }
    },
	*/
    complete(newValue, oldValue) {
		// Check for transitions from 0 to 1
		// console.log('Congrats value:', this.congrats);

		if ((oldValue === 0 && newValue === 1) && this.congrats == 1) {
			this.onCompleteChangedFromZeroToOne();
		}
		// Check for transitions from 9 to 10
		else if ((oldValue === 9 && newValue === 10) && this.congrats == 1) {
			this.onCompleteChangedFromNineToTen();
		}
		// Check for transitions from 19 to 20
		else if ((oldValue === 29 && newValue === 30) && this.congrats == 1) {
			this.onCompleteChangedFromNineteenToTwenty();
		}

		},
		stats: {
			handler(newStats) {
			this.animateValue('totalQuizzesAvailable', 0, newStats.totalQuizzesAvailable, this.animationDuration);
			this.animateValue('totalCompletedLastThreeYears', 0, newStats.totalCompletedLastThreeYears, this.animationDuration);
			this.animateValue('totalCompletedLastYear', 0, newStats.totalCompletedLastYear, this.animationDuration);
			this.animateValue('completedPercentageLastYear', 0, newStats.completedPercentageLastYear, this.animationDuration);
			},
			deep: true,
			immediate: true
		},
	},
	methods: {
		firstLoad: function() {
			//this.loading = true;
			this.loadContent();
			
			
			// console.log("ran in first load")
            // this.faqPosts = TrainingData;
        },
		 clearSearch() {
			this.searchStarted = false;
			this.search = "";
			this.selectedProduct = null;
  			this.activeProduct = null;
			this.updateURL();
		},
		searchPosts() {
			this.searchStarted = true;
			this.activeProduct = this.selectedProduct;
			this.currPage = 1;
			this.updateURL();
		},
		animateValue(key, start, end, duration) {
			let startTimestamp = null;
			const step = (timestamp) => {
			if (!startTimestamp) startTimestamp = timestamp;
			const progress = Math.min((timestamp - startTimestamp) / duration, 1);
			this.animatedStats[key] = Math.floor(progress * (end - start) + start);
			if (progress < 1) {
				window.requestAnimationFrame(step);
			} else {
				this.animatedStats[key] = end; // ensure exact final value
			}
			};
			window.requestAnimationFrame(step);
		},
		updateURL() {
			const query = { ...this.$route.query };

			// Handle search
			if (this.searchStarted && this.search.trim()) {
				query.search = this.search.trim();
			} else {
				delete query.search;
			}

			// Handle selectedProduct
			if (this.activeProduct) {
				query.product = this.activeProduct;
			} else {
				delete query.product;
			}

			// Always reset to page 1 when search or product filter changes
			// (Only if it's not already page 1, to avoid unnecessary history entries)
			if (query.search !== this.$route.query.search || query.product !== this.$route.query.product) {
				query.page = '1'; // Use string to match Vue Router behavior
			}

			// Push the new query (only if it actually changed)
			if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
				this.$router.push({ query });
			}
		},
		setPage(idx) {
			if (idx <= 0 || idx > this.totalPage) return;
			this.currPage = idx;
			this.$router.push({ query: { ...this.$route.query, page: idx } });
		},
        loadContent: function() {
			this.loading = true;
			
				return axios
					// /product-courses/all-courses/2DD2C984-A3DD-4923-AC52-5B04382989AD
					.get(`${this.server}/api/v1/product-courses/all-courses/${this.USERID}`, auth)
					// .get(`${this.server}/api/v1/product-courses`, auth)
					.then((response) => {
						//console.log(response);
						this.trainingData = response.data;
						// this.countComplete();
						this.loading = false;
						
						const el = document.getElementById("pag");
            			el.scrollIntoView({ behavior: "smooth" });
						console.log("here")
						console.log(this.trainingData);

					})
					.catch((error) => {
						if (error.request.status === 401) {
							this.$toast.error("Your session has timed out. Please sign in to continue.", { hideProgressBar: false, icon: false });
							this.$router.push("/");
						}
							// console.error("Error loading new content:", error);
					});
		
		},
		loadNewContent: function() {			
				return axios
					.get(`${this.server}/api/v1/cet-training-curricullum/${this.USERID}`, auth)
					.then((response) => {
						//console.log(response);
						this.trainingData = response.data;
						// console.log("new content loaded")
						// console.log(JSON.stringify(response.data, null, 2));
						return response.data.filter(item => item.complete === true || item.complete === "true").length;
						})
						.then((count) => {
							// Set the 'complete' field with the count
							this.complete = count;
							// console.log("count " + count)
							// console.log("complete: " + this.complete);
						})
						.catch((error) => {
							if (error.request.status === 401) {
								this.$toast.error("Your session has timed out. Please sign in to continue.", { hideProgressBar: false, icon: false });
								this.$router.push("/");
							}
							// console.error("Error loading new content:", error);
						});
		},
		completeQuiz: function(){
			

			const PAYLOAD = {
    			ModuleID: this.ModuleID,
    			UserID: this.USERID
			}

			return axios
			.post(`${this.server}/api/v1/cet-quiz`, PAYLOAD, auth)
			.then((response) => {
				// console.log(response.data)
				this.trainingData = response.data;
				let COUNT = this.trainingData.filter(item => item.complete === true || item.complete === "true").length;
				// console.log(COUNT);
				this.complete = COUNT;				
			})
			.catch((error) => {
				if (error.request.status === 401) {
					this.$toast.error("Your session has timed out. Please sign in to continue.", { hideProgressBar: false, icon: false });
					this.$router.push("/");
				}
				// console.error("Error loading data:", error);
				
			});
		},
		countComplete: function(){
			let count = this.trainingData.filter(item => item.complete === "true").length;

			this.complete = count;
			// alert(count);
			// console.log("ran")
		},
		congratsExplorer: function (link, type) {
				window.scrollTo(0, 0);
				this.$swal({
					html:
						'<div><h2 style="color: #000; margin-bottom: 5px;">Congratulations!</h2> <p style="font-weight: 300;">You\'ve just unlocked the CET Explorer Badge!</p>' +
						'<div style="text-align: left;"><small>' +
						'<br/>' +
						'</small><div style="background: #1b484e; text-align: center; padding: 20px; border-radius: 8px;"><img style="width: 150px;" src="/training-images/explorer-badge.svg" /><p style="color: #fff; margin-top: 10px;"><b>Explorer</b></p></div></div></div>',
					showCloseButton: false,
					showCancelButton: false,
					denyButtonText: `No`,
					customClass: {
						cancelButton: 'order-1 right-gap',
						confirmButton: 'order-2',
					}
				});
		},
		congratsVisionary: function (link, type) {
				window.scrollTo(0, 0);
				this.$swal({
					html:
						'<div><h2 style="color: #000; margin-bottom: 5px;">Congratulations!</h2> <p style="font-weight: 300;">You\'ve just unlocked the CET Visionary Badge!</p>' +
						'<div style="text-align: left;"><small>' +
						'<br/>' +
						'</small><div style="background: #1b484e; text-align: center; padding: 20px; border-radius: 8px;"><img style="width: 150px;" src="/training-images/visionary-badge.svg" /><p style="color: #fff; margin-top: 10px; margin-bottom:0;"><b>Visionary</b></p></div></div></div>',
					showCloseButton: false,
					showCancelButton: false,
					denyButtonText: `No`,
					customClass: {
						cancelButton: 'order-1 right-gap',
						confirmButton: 'order-2',
					}
				});
		},
		congratsInnovator: function (link, type) {
				window.scrollTo(0, 0);
				this.$swal({
					html:
						'<div><h2 style="color: #000; margin-bottom: 5px;">Congratulations!</h2> <p style="font-weight: 300;">You\'ve just unlocked the CET Innovator Badge!</p>' +
						'<div style="text-align: left;"><small>' +
						'<br/>' +
						'</small><div style="background: #1b484e; text-align: center; padding: 20px; border-radius: 8px;"><img style="width: 150px;" src="/training-images/innovator-badge.svg" /><p style="color: #fff; margin-top: 10px; margin-bottom:0;"><b>Innovator</b></p></div></div></div>',
					showCloseButton: false,
					showCancelButton: false,
					denyButtonText: `No`,
					customClass: {
						cancelButton: 'order-1 right-gap',
						confirmButton: 'order-2',
					}
				});
		},
		onCompleteChangedFromZeroToOne() {
				this.congratsExplorer();
				// alert('Complete changed from 0 to 1');

		},
		onCompleteChangedFromNineToTen() {
				this.congratsVisionary();
				// alert('Complete changed from 9 to 10');
		},
		onCompleteChangedFromNineteenToTwenty() {
				this.congratsInnovator();
				// alert('Complete changed from 19 to 20');
		},
		roundedHalfHour(length) {
			return Math.round((Number(length) / 60) * 2) / 2;
		},
		closeLightbox() {
      		this.lightboxVideo = "";
    	},
		closeQuizLightbox() {
			this.congrats = 0;
      		this.lightboxQuiz = null;
			this.ModuleID = null;
    	},
		showLightboxQuiz(quiz, id) {
			this.congrats = 1;
			this.lightboxQuiz = quiz;
			this.ModuleID = id;
		},
		cleanMediaHtml(media) {
			// Step 1: Replace all instances of \&quot; with "
			let decodedMedia = media.replace(/\\&quot;/g, '"');
			
			// Step 2: Remove backslashes that were used for escaping
			decodedMedia = decodedMedia.replace(/\\/g, '');

			// Step 3: Return the decoded result
			return decodedMedia;
		},

		// Method to clean and set the video for the lightbox
		showLightboxVideo(media) {
			const cleanedHtml = this.cleanMediaHtml(media);
			this.lightboxVideo = cleanedHtml;
		},
	},
	filters: {
		truncate: function(value) {
		if (value.length > 200) {
			value = value.substring(0, 200) + "...";
		}
		return value;
		},
		
	},
	computed: {
		showButton() {
			return this.search.trim().length > 0 || this.selectedProduct;
		},
		pageStart() {
			return (this.currPage - 1) * this.countOfPage;
		},
		totalPage() {
			return Math.ceil(this.filteredPosts.length / this.countOfPage);
		},
		activeNav() {
			return this.$store.state.activePage;
		},
		filteredPosts() {
			let results = this.trainingData; 
			// let results = this.courses; // or this.trainingData when you switch to API

			// Apply search filter (only if search is active and has text)
			if (this.searchStarted && this.search.trim().length > 0) {
			const term = this.search.toLowerCase();
			results = results.filter(item =>
				item.Title.toLowerCase().includes(term) ||
				(item.Description && item.Description.toLowerCase().includes(term))
			);
			}

			if (this.activeProduct) {
				results = results.filter(item =>
					item.Category === this.activeProduct
				);
			}

			return results;
		},
		paginatedPosts() {
		// Sort filteredPosts by createdAt in descending order (newest first), then slice for pagination
		return [...this.filteredPosts]
			// .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
			.slice(this.pageStart, this.pageStart + this.countOfPage);
		},
		

		totalLength() {
			const totalMinutes = this.faqPosts.reduce((sum, item) => sum + item.length, 0);
			return (totalMinutes / 60).toFixed(2); // Returns result in hours with 2 decimal points
    	},
		totalMinutes() {
      		return this.faqPosts.reduce((total, course) => total + course.length, 0);
    	},
		// Convert minutes to hours, rounding to the nearest half-hour
		roundedTotalHours() {
			const hours = this.totalMinutes / 60;
			return Math.round(hours * 2) / 2; // Rounds to nearest half-hour
		},
		// Display 'hour' or 'hours' depending on total hours
		hourLabel() {
			return this.roundedTotalHours === 1 ? 'Hour' : 'Hours';
		},
		USERID() {
			return this.$store.state.user.UserId;
		},
		stats() {
			const now = new Date();
			const threeYearsAgo = new Date(now);
			threeYearsAgo.setFullYear(now.getFullYear() - 3);

			// Jan 1st of current year instead of last 365 days
			const currentYearStart = new Date(now.getFullYear(), 0, 1); // Month 0 = January

			let totalAvailable = 0;
			let completed3y = 0;
			let completed1y = 0;

			// Use this.trainingData instead of this.filteredPosts
			// so stats don't change when user filters/searches
			this.trainingData.forEach(item => {
				if (item.quizzes && Array.isArray(item.quizzes)) {
					item.quizzes.forEach(quiz => {
						totalAvailable++;

						if (quiz.complete && quiz.completedAt) {
							const completedDate = new Date(quiz.completedAt);

							// Skip invalid dates
							if (!isNaN(completedDate.getTime())) {
								if (completedDate >= threeYearsAgo) {
									completed3y++;
								}
								// Check if completed since Jan 1st of current year
								if (completedDate >= currentYearStart) {
									completed1y++;
								}
							}
						}
					});
				}
			});

			const percentageLastYear = totalAvailable > 0
				? Math.round((completed1y / totalAvailable) * 100)
				: 0;

			return {
				totalQuizzesAvailable: totalAvailable,
				totalCompletedLastThreeYears: completed3y,
				totalCompletedLastYear: completed1y,
				completedPercentageLastYear: percentageLastYear
			};
		},
		currentYear() {
        	return new Date().getFullYear();
    	},
	},
	created() {
		this.$store.commit("showNavigation");
	},

	mounted() {
		this.firstLoad().then(() => {
			if (this.$route.query.search) {
				this.searchStarted = true;
			}
			if (this.$route.query.page) {
				this.setPage(parseInt(this.$route.query.page));
			}
		});
	},
};
</script>


<style scoped>
	.search{
  margin-left: auto;
}
.search-btns {
  display: flex;
  margin-top: 10px;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 23px 10px;
  cursor: pointer;
  max-height: 40px;
}
.search-btns .clear {
  margin-left: auto;
}
.search-btns .search {
  margin-left: 5px;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}
.clear-btn {
  position: absolute;
  right: 0;
  top: 14px;
  border: none;
  background: none;
}
.clear-hide {
  display: none !important;
}
.input-wrap {
  position: relative;
  display: block;
}
.right-side{
  display: flex;
}
.thesearchbutton{
  margin-left: auto;
}

.bgwhite {
	background: #fff;
}
.faq-heading {
	margin-bottom: 0 !important;
}
.collapse {
	padding: 0px 10px !important;
}
.collapse.show {
	padding: 0px 22px !important;
}
.faq-01 .btn {
	text-decoration: none !important;
}
.faq-01 .btn:hover {
	text-decoration: none !important;
}

.btn-link {
	color: #333;
}

.btn-link i {
	color: rgba(92, 109, 126, 0.9);
}

.btn-link:hover {
	color: #000;
	text-decoration: none !important;
	background-color: transparent;
	border-color: transparent;
}

.btn-link:focus {
	color: #000;
	text-decoration: none !important;
}

.accordion h5 {
	margin-bottom: 0 !important;
	font-weight: bold !important;
	font-size: 1.1em !important;
	line-height: 1.2;
}

.accordion div {
	padding: 10px;
}
.pixelsbg {
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23505a65'/%3E%3Cstop offset='1' stop-color='%23505a65' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233f474f'/%3E%3Cstop offset='1' stop-color='%233f474f' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23383e45'/%3E%3Cstop offset='1' stop-color='%23383e45' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%23474f58' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%23464f58' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%23464e57' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%23454e56' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23454d56' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%23444d55' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%23444c55' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%23434b54' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%23434b53' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23424a53' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23424a52' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23404850' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23404750' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%233f474f' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%233e454d' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%233e454c' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%233d444c' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%233d444b' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%233c434b' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%233c424a' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%233b4249' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%233b4149' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%233a4148' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%233a4047' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%23394047' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%23393f46' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%23383f46' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%23394047' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%233b4148' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%233c434a' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%233d444c' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%233f464e' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%2340474f' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23414951' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23434a53' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23444c55' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%23454d57' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%23474f58' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%2348515a' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%2349525c' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%234b545e' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%234c5560' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%234d5761' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%234f5963' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%23505a65' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%23515c67' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%23535d69' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%23545f6b' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2355616c' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2357626e' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%23586470' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%235a6672' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%235b6774' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%235c6976' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b78' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%235f6c7a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23616e7c' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%2362707d' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%2363717f' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23657381' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23667583' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23687685' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525b' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c555f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5660' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234d5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234e5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%234f5a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23505b65' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%23545f6a' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355606c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356616d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636e' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6773' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235c6976' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235d6a77' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%235f6d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23606e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23616f7c' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647280' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657382' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%23383e45' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='.5'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233c768a'/%3E%3Cstop offset='1' stop-color='%233c768a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23305e6e'/%3E%3Cstop offset='1' stop-color='%23305e6e' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%2346505a' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%2344515c' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%2343515d' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%2341525e' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23405260' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%233e5361' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%233d5462' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%233c5463' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%233a5565' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23395666' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23375767' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23365969' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23345a6a' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23335b6b' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23325d6c' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%23305e6e' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%232f606f' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%232d6170' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%232c6372' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%232b6573' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%23296774' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%23286975' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%23266b77' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%23256d78' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%23246f79' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%2322727a' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%2321747c' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%2320767d' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%231e797e' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%231d7c80' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%231b7e81' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%231c8083' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%231d8083' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%231f7f84' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%23217e85' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%23227e85' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%23247d86' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23267c87' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23287c87' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23297b88' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%232b7a88' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%232d7a88' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%232f7989' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%23317989' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%23337889' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%2335788a' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%2337778a' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%233a778a' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%233c768a' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%233e768a' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%2340758a' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%2343758a' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2345758a' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2347758a' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%234a758a' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%234c748a' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%234e748a' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%2351748a' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%2354758a' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%2356758a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23597589' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%235b7589' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%235e7689' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23617688' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23637788' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23667787' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525c' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c565f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5761' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234e5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234f5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%23505a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23515b66' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%2354606b' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355616c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356626d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636f' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6774' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235d6a76' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235e6b78' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235f6c79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%23606d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23616e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23626f7d' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647281' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657482' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%231a8182' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='0.79'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
.header-divide {
    margin-top: 20px;
    margin-bottom: 20px;
    border: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.vid-link:hover{
	text-decoration: underline;
	cursor: pointer;
}

.complete {
	position: relative;
	display: inline-block;
	color: black; /* Set text color */
}

.complete::after {
	content: "";
	position: absolute;
	left: 0;
	right: 0;
	top: 50%; /* Position the line */
	height: 2px; /* Adjust thickness */
	background-color: #00b4b4; /* Set line color */
	z-index: 1;
}
.closeX {
    color: #fff;
    font-size: 3em;
    position: absolute;
    top: 10px;
    left: 20px;
    cursor: pointer;
    -webkit-transition: color 0.5s ease;
    transition: color 0.5s ease;
}

.cool-desc {
  margin-top: 5px;
  min-height: 120px;
}
.faq-heading,
h3[id^="faq-heading"] {
  /* Single-line truncation with ellipsis */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  /* Optional: prevent any height issues */
  max-width: 100%;                /* or a fixed max-width if needed */
  display: block;                 /* or inline-block depending on layout */
}
 .time-desc {
		display: none;
}
@media screen and (min-width: 1200px) {
    .time-desc {
		display: block;
	}
}
</style>
